import type { RecommendClient, RecommendQueriesResponse } from '@algolia/recommend'

import type { RecommendService } from './recommend.service'
import type { ProductHit } from './search.service'

export class AlgoliaRecommendService implements RecommendService {
  constructor(private readonly recommendClient: RecommendClient) {}

  async fetchAlgoliaSimilarProducts(
    indexName: string,
    productId: string,
    nbItemsToFetch: number,
  ): Promise<RecommendQueriesResponse<ProductHit>> {
    const result = await this.recommendClient.getRelatedProducts<ProductHit>([
      {
        indexName,
        objectID: productId,
        maxRecommendations: nbItemsToFetch,
      },
    ])
    return result
  }

  async fetchAlgoliaFrequentlyBoughtTogetherProducts(
    indexName: string,
    productId: string,
    nbItemsToFetch: number,
  ): Promise<RecommendQueriesResponse<ProductHit>> {
    const result = await this.recommendClient.getFrequentlyBoughtTogether<ProductHit>([
      { indexName, objectID: productId, maxRecommendations: nbItemsToFetch },
    ])
    return result
  }
}
